import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

import {i18n} from '../i18n'

Vue.use(VueAxios,axios)

Vue.axios.defaults.baseURL = process.env.VUE_APP_BACKEND_SERVER
Vue.axios.defaults.headers = {
  "Content-Type": 'application/json'
}

var numberOfAjaxCAllPending = 0;
var numberOfImagesPending = 0;
var debugMode = process.env.VUE_APP_DEBUGMODE == 1 ? true : false;

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  numberOfAjaxCAllPending++;
  // show loader
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
Vue.axios.interceptors.response.use(function (response) {
  numberOfAjaxCAllPending--;
  //console.log("------------  Ajax pending", numberOfAjaxCAllPending);

  if (numberOfAjaxCAllPending == 0) {
    //hide loader
  }
  return response;
}, function (error) {
  numberOfAjaxCAllPending--;
  if (numberOfAjaxCAllPending == 0) {
    //hide loader
  }
  return Promise.reject(error);
});


Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    configbackend: null,
    skupuenteactivo: null,
    puentelavadoactivo : null,
    isMenuModalActive: false,
    puentes: null,
    modelo: null,
    colores_carenado : null,
    colores_cepillos : null,
    colores_vinilo : null,
    variaciones: [],
    loading: false,
    tipo_rodillos: "Liso",
    ordenvariaciones: ['estructura','modelos','carenado-posterior','cabut','puerta','vinilo','luminoso','pictograma','luminososuperior','pictogramasuperior','lavarruedas','logo_istobal','cepillo'],
    procesar_cola : false,
    solicitar: false,
    firstloadimage: true,
    confighash: null,
    sharelink: null,
    isconfigfromhash: false,
    actionToBackend: '',
    cambioscontabilizados: 0,
    parteskeys: ['cabut','puerta','vinilo','carenado','carenado-posterior','pictograma','luminoso','pictogramasuperior','luminososuperior','lavarruedas',],
    parteseleccionadas: {},
    langs: [],
    pais: "",
    puenteDefault: "",
    partesocultas:[],
    partesocultarselector:[],
    colorConfig1: null,
    colorConfig2: null,
    configuracionStandardActiva: { codigo: null, colorConfig1: null, colorConfig2: null},




  },
  getters: {
    getConfigBackend(state){
      return state.configbackend
    },
    getPuenteLavadoActivo(state){
      return state.puentelavadoactivo
    },
    getIsMenuModalActive(state){
      return state.isMenuModalActive
    },
    getSKUActivo(state){
      return state.skupuenteactivo
    },
    getPuentes(state){
      return state.puentes
    },
    getColoresCarenado(state){
      return state.colores_carenado
    },
    getColoresCepillos(state){
      return state.colores_cepillos
    },
    getColoresVinilo(state){
      return state.colores_vinilo
    },
    getVariaciones(state){
      return state.variaciones
    },
    getModeloActivo(state){
      return state.modelo
    },
    getImagenFrontal(state){

      let imgdefault = require( '../assets/img/'+state.skupuenteactivo+'-default-front.jpg' );
      if (state.puentelavadoactivo.imagen.frontal == null){
        return imgdefault

      }else{
        return state.puentelavadoactivo.imagen.frontal
      }
    },
    getImagenTrasera(state){
      let imgdefault = require ('../assets/img/'+state.skupuenteactivo+'-default-back.jpg')
      if (state.puentelavadoactivo.imagen.trasera == null){
        return imgdefault

      }else{
        return state.puentelavadoactivo.imagen.trasera
      }
    },
    isloading(state){
      return state.loading
   },
    getTipoRodillos(state){
      return state.tipo_rodillos
    },
    getProcesarCola(state){
      return state.procesar_cola
    },
    getSolicitar(state){
      return state.solicitar
    },
    getFirstLoadImage(state){
      return state.firstloadimage
    },
    getConfigHash(state){
      return state.confighash
    },
    getShareLink(state){
      return state.sharelink
    },
    getIsConfigFromHash(state){
      return state.isconfigfromhash
    },
    getActionToBackend(state){
      return state.actionToBackend
    },
    getCambiosContabilizados(state){
      return state.cambioscontabilizados
    },
    getPartesKeys(state){
      return state.parteskeys
    },
    getPartesSeleccionadas(state){
      return state.parteseleccionadas
    },
    getLangs(state){
      return state.langs
    },
    getPais(state){
      return state.pais
    },
    getPuenteDefault(state){
      return state.puenteDefault
    },
    getPartesOcultas(state){
      return state.partesocultas
    },
    getPartesOcultarSelector(state){
      return state.partesocultarselector
    },
    getColorConfig1(state){
      return state.colorConfig1
    },
    getColorConfig2(state){
      return state.colorConfig2
    },
    getConfiguracionStandardActiva(state){
      return state.configuracionStandardActiva
    },



  },
  mutations: {
    setConfigBackend(state,config){
      state.configbackend = config
    },
    setSkuPuenteActivo(state,sku){
      state.skupuenteactivo = sku
    },
    setPuenteLavadoActivo(state,puente){
      state.puentelavadoactivo = puente
    },
    setIsMenuModalActive(state,value){
      state.isMenuModalActive = value
    },
    setPuentes(state,value){
      state.puentes = value
    },
    setColoresCarenado(state,value){
      state.colores_carenado = value
    },
    setColoresCepillos(state,value){
      state.colores_cepillos = value
    },
    setColoresVinilo(state,value){
      state.colores_vinilo = value
    },
    addVariacion(state,value){
      state.variaciones.push(value)
    },
    setVariaciones(state,value){
      state.variaciones = value
    },
    setModelo(state,value){
      state.modelo = value
    },
    setImagenPuente(state,val){
      state.puentelavadoactivo.imagen[val.vista] = val.imagen
      numberOfImagesPending--;
    },
    setLoading(state,val){
      state.loading = val
    },
    setTipoRodillos(state,val){
      state.tipo_rodillos = val
    },
    orderVariaciones(state){
      var ordenado= []
      if (typeof state.ordenvariaciones!=='undefined' && typeof state.variaciones !=='undefined'){
        state.ordenvariaciones.forEach(el => {
          let t = state.variaciones.filter(e => e.parte == el)
          ordenado.push(t)


        })
        state.variaciones=ordenado.flat()
      }

    },
    setProcesarCola(state,val){
      state.procesar_cola = val
    },
    setSolicitar(state,val){
      state.solicitar = val
    },
    setFirstLoadImage(state,val){
      state.firstloadimage = val
    },
    setConfigHash(state,val){
      state.confighash = val
    },
    setShareLink(state,val){
      state.sharelink = process.env.VUE_APP_URL+'/'+state.pais+'/'+i18n.locale+'/sc/'+val
    },
    setIsConfigFromHash(state,val){
      state.isconfigfromhash = val

    },
    setActionToBackend(state,val){
      state.actionToBackend = val
    },
    setCambiosContabilizados(state,val){
       state.cambioscontabilizados = val
    },
    addCambiosContabilizados(state){
      state.cambioscontabilizados += 1
    },
    setParteSeleccionada(state,ps){
      state.parteseleccionadas[ps.parte] = ps.val
    },
    setLangs(state,val){
      state.langs = val
    },
    setPais(state,val){
      state.pais = val
    },
    setPuenteDefault(state,val){
      state.puenteDefault = val
    },
    setPartesOcultas(state,val){
      state.partesocultas = val
    },
    setPartesOcultarSelector(state,val){
      state.partesocultarselector = val
    },
    setColorConfig1(state,val){
      state.colorConfig1 = val
      state.configuracionStandardActiva.colorConfig1 = val
    },
    setColorConfig2(state,val){
      state.colorConfig2 = val
      state.configuracionStandardActiva.colorConfig2 = val
    },
    setConfiguracionStandardActiva(state,val){
      state.configuracionStandardActiva.codigo = val.codigo

    }


  },
  actions: {
    initFromBackend: function (context) {

      let url = 'api/back/initialize/'+context.getters.getPais

      axios.get(url).then((response) => {

        if (response.data!==''){

          context.commit('setConfigBackend',response.data.data)

          //Obtenemos los colores carenado
          let coloresCarenado = []
          let coloresCepillos = []
          let coloresVinilo = []

          if (process.env.VUE_APP_ES_PUBLIC==0 || process.env.VUE_APP_ENABLE_ALL_COLORS==1){
            coloresCarenado = context.getters.getConfigBackend.colores.map((el) => { return el.ral})
            coloresCepillos = context.getters.getConfigBackend.colorescepillos.map((el) => { return {ral: el.ral , codigo: el.codigo}})
            coloresVinilo = context.getters.getConfigBackend.coloresvinilo.map((el) => { return el.ral})
          }else{
            coloresCarenado = context.getters.getConfigBackend.colores_publica.map((el) => { return el.ral})
            coloresCepillos = context.getters.getConfigBackend.colorescepillos_publica.map((el) => { return {ral: el.ral , codigo: el.codigo}})
            coloresVinilo = context.getters.getConfigBackend.coloresvinilo_publica.map((el) => { return el.ral})
          }


         let puentes =  context.getters.getConfigBackend.config.puentes
         let langs =  context.getters.getConfigBackend.config.idiomas
          context.commit('setPuentes',puentes )
          context.commit('setLangs',langs)


          context.commit('setColoresCarenado', coloresCarenado)
          context.commit('setColoresCepillos', coloresCepillos)
          context.commit('setColoresVinilo', coloresVinilo)
          context.commit('setVariaciones', [])
          context.commit('setPuenteDefault',puentes[0].sku)




        }

      })

      //context.commit('setPuenteLavadoActivo',puente)
    },
    getConfigPuenteFromBackend: function (context,sku) {


      let pais = context.getters.getPais
      let url = 'api/back/get-puente/'+pais+'/'+sku

      context.commit('setCambiosContabilizados', 0)

      context.commit('setLoading', true)
      context.commit('setActionToBackend','getConfigPuenteFromBackend')

      axios.get(url).then((response) => {

        if (response.data!==''){
          context.commit('setFirstLoadImage',true)
          context.commit('setSkuPuenteActivo',response.data.data.sku)
          context.commit('setPuenteLavadoActivo',response.data.data)

          if (context.getters.getConfigHash!== null){
            let config = context.getters.getConfigHash

            context.commit('setModelo',config.modelo)
            context.commit('setTipoRodillos',config.tipo_rodillos)
            context.commit('setVariaciones',config.variaciones)
            context.commit('setIsConfigFromHash', true)
            context.commit('setConfiguracionStandardActiva',config.conf_standard)
            context.commit('setColorConfig1',config.conf_standard.colorConfig1)
            context.commit('setColorConfig2',config.conf_standard.colorConfig2)

            //context.commit('setConfigHash',null)
          }else{
            context.commit('setModelo', response.data.data.modelos.find(v => v.default == true).codigo)
            context.commit('setVariaciones',[])
            context.commit('setIsConfigFromHash', false)
          }
          if (debugMode === true) console.log('Pido frontal. Get config puente')
          context.dispatch('solicitarImagenes','frontal')
          if (debugMode === true) console.log('Pido trasera. Get config puente')
          context.dispatch('solicitarImagenes','trasera')
          ////context.dispatch('solicitaImgFrontAndBack')

          //context.commit('setLoading', false)


        }

      })

      //context.commit('setPuenteLavadoActivo',puente)
    },
    coloresRalToCodigo: function (context,codigo){
      if (codigo && codigo!==''){
        if (context.state.configbackend!==null && context.state.configbackend.colores && typeof context.state.configbackend.colores!=='undefined' ){
          if (debugMode === true) console.log('coloresRalToCodigo: Error en colores '+codigo+' !!!', context.state.configbackend)
          const ral = context.state.configbackend.colores.find(el => el.codigo == codigo)?.ral
          if (ral && ral!=='')
            return ral
          else
            return ''
        }else{
          return new Promise(resolve => {
            //El valor de configbackend aun no esta establecido ya que viene de una llamada asincrona por tanto espero
            // 1 segundo a que se establezca y devuelvo el valor
            if (debugMode === true) console.log('coloresRalToCodigo: Entramos a la promesa !!!')
            setTimeout(() => { resolve(context.state.configbackend.colores.find(el => el.codigo == codigo).ral),1000})
          })
        }

      }else{
        return ''
      }

    },
    changeModeloDefault: function (context, modelo) {

      let puente = context.getters.getPuenteLavadoActivo

      puente.modelos.forEach(el => {
        if (el.codigo==modelo){
          el.default = true
        }else{
          el.default = false
        }
      })
      //console.log(modelo)
      //context.commit('setPuenteLavadoActivo',puente)
      context.commit('setModelo',modelo)
      if (debugMode === true) console.log('Pido frontal (Cambiar modelo default)')
      context.dispatch('solicitarImagenes','frontal')
      if (debugMode === true) console.log('Pido trasera (Cambiar modelo default)')
      context.dispatch('solicitarImagenes','trasera')
      //context.dispatch('solicitaImgFrontAndBack')

    },
    registrarVariacion: function (context,variacion){



      if (variacion.parte=='cepillo') {
        if (variacion.cambio=='tipo'){
          let nvariacion = []
          if (Array.isArray(context.state.variaciones)){
            nvariacion = context.state.variaciones.filter( val => {
              return val.parte!=='cepillo'
            })
          }


          context.commit('setVariaciones',nvariacion)
        }else if (variacion.cambio=='color'){

          let nvariacion = context.state.variaciones.filter( val => {
            return val.teja !== variacion.teja
          })

          context.commit('setVariaciones',nvariacion)
        }
        context.commit('addVariacion',variacion)
      }else{
        if (variacion.cambio == 'mostrar'){
          if (variacion.valor){
            context.commit('addVariacion',variacion)
          }else {

            let nvariacion = context.state.variaciones.filter( val => {
              return val.parte!==variacion.parte
            })
            context.commit('setVariaciones',nvariacion)
            context.commit('addVariacion',variacion)
          }
        }else if (variacion.cambio=='color'){

          let nvariacion = context.state.variaciones.filter( val => {
            return val.parte!==variacion.parte
          })


          context.commit('setVariaciones',nvariacion)
          context.commit('addVariacion',variacion)

        }else if(variacion.cambio == 'opcion'){
          //console.log('Cambio de opcion VUEX')
         // console.log(variacion)
          let nvariacion = context.state.variaciones.filter( val => {
            return val.parte!==variacion.parte || (val.parte == variacion.parte && variacion.cambio !=='opcion')
          })
          //console.log(nvariacion)
          context.commit('setVariaciones',nvariacion)

          context.commit('addVariacion',variacion)
          //console.log(context.getters.getVariaciones)
          //context.commit('')
          context.commit('setProcesarCola', true)

        }

      }
      // eslint-disable-next-line no-empty
      if (context.getters.getSolicitar){
        if (context.getters.isloading){
          //console.log('Esta cargandooooo !!. No hacemos nada !!!!')
          //context.commit('setProcesarCola', false)
        }else{
          //console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!Solicitamos imagenes !!!!!')
          //console.log(context.getters.getVariaciones)
          if (debugMode === true) console.log('Pido frontal (Registrar variación)')
          context.dispatch('solicitarImagenes','frontal')
          if (debugMode === true) console.log('Pido trasera (Registrar variación)')
          context.dispatch('solicitarImagenes','trasera')
          //context.dispatch('solicitaImgFrontAndBack')
        }
      }





    },
    solicitarImagenes: async function (context,vista='frontal'){
      let url = 'api/back/solicitar-imagenes-puente'

      //if (context.getters.getSolicitar){
        context.commit('setLoading', true)

        //Ordenamos variaciones antes de mandar
        context.commit('orderVariaciones')
        if (typeof context.getters.getVariaciones !=='undefined' && context.getters.getVariaciones.length>0){
          numberOfImagesPending++;
          await axios.post(url, {
                sku: context.state.skupuenteactivo,
                pais: context.state.pais,
                modelo: context.state.modelo,
                variaciones: context.state.variaciones,
                tipo_rodillos: context.state.tipo_rodillos,
                conf_standard: context.state.configuracionStandardActiva,
                vista: vista
              }
          ).then((response) => {
            if (response.data !== '') {
              context.commit('setImagenPuente',{vista: vista, imagen: response.data.imagen})
              context.commit('setConfigHash',response.data.confighash)
              context.commit('setShareLink',response.data.confighash)
              //context.commit('setImagenPuente',{vista: 'trasera', imagen: response.data.trasera})
              //context.commit('setLoading', false)

              if (context.getters.getFirstLoadImage){
                context.commit('setFirstLoadImage',false)
              }
            }
            if (context.getters.getProcesarCola){
              //console.log('Solicitamos de nuevo imagenes porque hay cola por procesar !')
              context.commit('setProcesarCola', false)
              //console.log('Pido frontal (Solicitar Imágenes. Cola)')
              context.dispatch('solicitarImagenes','frontal')
              //console.log('Pido trasera (Solicitar Imágenes. Cola)')
              context.dispatch('solicitarImagenes','trasera')
              //console.log('Procesar cola True solicitamos !')
              //context.dispatch('solicitaImgFrontAndBack')

            }else{
              if (numberOfImagesPending==0){
                context.commit('setLoading', false)
              }
            }
          })
        }else{
          //context.commit('setLoading', false)
          if (numberOfAjaxCAllPending==0){
            context.commit('setLoading', false)
          }else{
            if (debugMode === true) console.log('Aun quedan pendientes !!!')
          }
        }
      //}



  },
    getConfigWithHash: function (context,hash) {
      /*let puente = {
        sku: 'Test',
        config: {

        }
      }*/
      let url = 'api/back/get-saved-config/'+hash

      //context.commit('setLoading', true)
      context.commit('setActionToBackend','getConfigWithHash')

      axios.get(url).then((response) => {

        if (response.data!==''){

          if ('data' in response.data){
            let config = response.data.data;
            context.commit('setConfigHash',config)
            context.dispatch('getConfigPuenteFromBackend',config.sku)
          }else{
            if (debugMode === true) console.log('Configuracion no encontrada')
          }


        }

      })

      //context.commit('setPuenteLavadoActivo',puente)
    },
    getPDFWithHash: function (context,hash) {

      let url = 'api/back/pdf/'+hash+'/'+context.getters.getPais+'/'+i18n.locale.toLowerCase()+'/S'



      axios.get(url).then((response) => {

        if (response.data!==''){
          if (debugMode === true) console.log('Response data es:')
          if ('pdf' in response.data){
            let binary = atob(response.data.pdf.replace(/\s/g, ''))
            let len = binary.length;
            let buffer = new ArrayBuffer(len);
            let view = new Uint8Array(buffer);
            let a = document.createElement("a");
            for (var i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }
            //console.log(response.data.pdf)
            const file = new Blob(
                [view],
                {
                  type: 'application/pdf',
                  name: 'prueba.pdf'
                });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = response.data.nombrefichero;
            a.click();

          }else{
            if (debugMode === true) console.log('Configuracion no encontrada')
          }


        }

      })

      //context.commit('setPuenteLavadoActivo',puente)
    },
    getPDFImageWithHash: function (context,hash) {

      let url = 'api/back/pdf-image/'+hash+'/'+context.getters.getPais+'/'+i18n.locale.toLowerCase()+'/S'



      axios.get(url).then((response) => {

        if (response.data!==''){
          if (debugMode === true) console.log('Response PDFImage data es:')
          if ('pdfImage' in response.data){
            let binary = atob(response.data.pdfImage.replace(/\s/g, ''))
            let len = binary.length;
            let buffer = new ArrayBuffer(len);
            let view = new Uint8Array(buffer);
            let a = document.createElement("a");
            for (var i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }
            //if (debugMode === true) console.log(response.data.pdfImage)
            const file = new Blob(
                [view],
                {
                  type: 'image/jpeg',
                  name: 'prueba.jpg'
                });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = response.data.nombrefichero;
            a.click();

          }else{
            if (debugMode === true) console.log('Sin respuesta PDFImage')
          }


        }

      })

      //context.commit('setPuenteLavadoActivo',puente)
    },
    sendEmail: async function (context,email) {

      try {
        let url = '/api/back/mail/sendmail'

        let respuesta = null

        await axios.post(url,{
          hash: context.state.confighash,
          lang: i18n.locale,
          email: email,
          pais: context.getters.getPais

        }).then((response) => {

        if (response.data!==''){
            //console.log(response.data.error)

            respuesta = response.data.error



          }

        })
        return await respuesta


      } catch (err) {
        return 1

      }



    },
    aplicarConfiguracion: function (context,config){
      if (debugMode === true) console.log('Aplicando configuracion ....')
      if (config === null){

        config =context.getters.getPuenteLavadoActivo.configuracionesestandar[0]
      }
      context.commit('setPartesOcultas',config.partesocultarcomponente)
      context.commit('setPartesOcultarSelector',config.partesocultarselectorcolor)

    },
    limpiarVariaciones: function (context,filtro){

      let limpio  = context.state.variaciones.filter(v => v.parte !== filtro.parte || v.cambio !== filtro.cambio)

      context.commit('setVariaciones', limpio)

    },
    solicitaImgFrontAndBack: async function (context){
      //TODO: funcion para intentar resolver que loading se desactive SOLO cuando las 2 imagenes : frontal y trasera ya
      //TODO: estén cargadas.

      let frontalCargada = false
      let traseraCargada = false
      await context.dispatch('solicitarImagenes','frontal')
          .then((frontalCargada = true))
          .catch(context.dispatch('solicitarImagenes','frontal'))
      await context.dispatch('solicitarImagenes','trasera')
          .then(traseraCargada=true)
          .catch(context.dispatch('solicitarImagenes','frontal'))

      if (frontalCargada && traseraCargada){
        if (debugMode === true) console.log('Imagenes cargadas !')
        context.commit('setLoading', false)

      }


    }

  },
  modules: {
  }
})
